// extracted by mini-css-extract-plugin
export default {"root":"CandidateFooter_root__CjbKu"};